import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SeoWorkService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/seowork`;

  constructor(private http: HttpClient) { }

  getSeoWorkSettings(customerId: number): Observable<Boo.Objects.Work.SeoMinute.SeoWorkSettings> {
    const params = new HttpParams().set('customerId', customerId);
    return this.http.get<Boo.Objects.Work.SeoMinute.SeoWorkSettings>(`${this.baseUrl}/GetSeoWorkSettings`, { params: params });
  }

  getOpenWorkRequests(customerId: number): Observable<Boo.Objects.Work.SeoMinute.WorkRequestDetail[]> {
    return this.http.get<Boo.Objects.Work.SeoMinute.WorkRequestDetail[]>(`${this.baseUrl}/workrequests/open/${customerId}`);
  }

  saveSeoWorkSettings(
    customerId: number,
    seoWorkSettings: Boo.Objects.Work.SeoMinute.SeoWorkSettings,
    workRequestDetails: Boo.Objects.Work.SeoMinute.WorkRequestDetail[],
    itemsToDelete: Boo.Objects.Work.SeoMinute.WorkRequestDetail[],
    noteText: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/SaveSeoWorkSettings`, { customerId: customerId, seoWorkSettings: seoWorkSettings, workRequestDetails: workRequestDetails, itemsToDelete: itemsToDelete, noteText: noteText });
  }

  deleteSeoWorkRequest(seoWorkItem: Boo.Objects.Work.SeoMinute.WorkRequestDetail): Observable<any> {
    return this.http.post(`${this.baseUrl}/DeleteSeoWorkRequest`, seoWorkItem);
  }

  deleteSeoWorkItems(seoWorkItems: Boo.Objects.Work.SeoMinute.WorkRequestDetail[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/DeleteSeoWorkRequests`, seoWorkItems);
  }
  
  getOpenWorkRequestsForPastPeriods(customerId: number): Observable<Boo.Objects.Work.SeoMinute.WorkRequestDetail[]> {
    const params = new HttpParams().set('customerId', customerId);
    return this.http.get<Boo.Objects.Work.SeoMinute.WorkRequestDetail[]>(`${this.baseUrl}/GetOpenWorkRequestsForPastPeriods`, { params: params });
  }

  getWorkRequest(workRequestId: number): Observable<Boo.Objects.Work.WorkRequest> {
    const params = new HttpParams().set('workRequestId', workRequestId);
    return this.http.get<Boo.Objects.Work.WorkRequest>(`${this.baseUrl}/GetWorkRequest`, { params: params });
  }

  getCustomerIdsWithTaskTypeInFutureAllocations(partnerId: number, taskTypeId: number, amountToTake: number): Observable<number[]> {
    const params = new HttpParams()
      .set('partnerId', partnerId)
      .set('taskTypeId', taskTypeId)
      .set('amountToTake', amountToTake);
    return this.http.get<number[]>(`${this.baseUrl}/GetCustomerIdsWithTaskTypeInFutureAllocations`, { params: params });
  }

  getPartnerTaskTypeUsage(partnerId: number): Observable<Boo.Objects.PartnerTaskTypeUsage[]> {
    const params = new HttpParams().set('partnerId', partnerId);
    return this.http.get<Boo.Objects.PartnerTaskTypeUsage[]>(`${this.baseUrl}/GetPartnerTaskTypeUsage`, { params: params });
  }

  editSeoWorkRequest(seoWorkItem: Boo.Objects.Work.SeoMinute.WorkRequestDetail): Observable<any> {
    return this.http.post(`${this.baseUrl}/EditSeoWorkRequest`, seoWorkItem);
  }

  deleteWorkRequestFile(workRequestFile: Boo.Objects.Work.WorkRequestFile, workOrderItemWorkTypeId: number, workOrderItemWorkId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/DeleteWorkRequestFile`,
      {
          workRequestFile: workRequestFile,
          workOrderItemWorkTypeId: workOrderItemWorkTypeId,
          workOrderItemWorkId: workOrderItemWorkId
      });
  }

  checkWorkOrderBlocks(customerId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/CheckWorkOrderBlocks`, customerId);
  }

  forecastWork(
    customerId: number,
    workRequestDetails: Boo.Objects.Work.SeoMinute.WorkRequestDetail[]): Observable<Boo.Objects.Work.WorkRequest[]> {
    return this.http.post<Boo.Objects.Work.WorkRequest[]>(`${this.baseUrl}/ForecastWork`, {
      customerId: customerId,
      workRequestDetails: workRequestDetails});
  }

  getCurrentPeriodDetails(customerId: number): Observable<Boo.Objects.Work.SeoMinute.PeriodDetails> {
    const params = new HttpParams().set('customerId', customerId);
    return this.http.get<Boo.Objects.Work.SeoMinute.PeriodDetails>(`${this.baseUrl}/CurrentPeriodDetails`, { params: params });
  }
}
